<ejs-dialog
	#modal
	(close)="closeModal()"
	cssClass="modal-lg"
	[attr.data-test-id]="'receivePaymentModal'">
	<ng-template #header>
		<div class="dlg-template">Payment Items</div>
	</ng-template>
	<ng-template #content>
		<form
			  [formGroup]="formGroup"
			  #templateForm="ngForm">
			<gandalf-lib-validation-messages
					*ngIf="formGroup.invalid && templateForm.submitted"
					[form]="formGroup"
					[validateSubArrays]="false"
					[requestObj]="request"
					[attr.data-test-id]="'receivePaymentModalValidationMessages'"></gandalf-lib-validation-messages>
			<h4 class="section-title bg-default mrgn-btm">
				Invoice #{{invoiceId}} for <strong>{{patientInfo?.patientNameResponse | patientName}}</strong>
				<div class="alert alert-success display-inline-block text-nowrap padding-sm margin-bottom-0 margin-left-sm" *ngIf="patientCredit > 0">{{patientCredit | currency}} Available Credit</div>
			</h4>
			<div class="margin-bottom-sm">
				<div *ngIf="showTable && !readOnly">
					<ng-container *ngIf="canTransferOrWriteoff(); else noOptions">
						<div class="row mb-3">
							<label class="col-md-2 col-form-label">{{ transferTypeText() }}</label>
							<div class="col-md-10">
								<div class="d-flex flex-wrap align-items-center gap-2">
									<span class="display-inline-block margin-right-md vertical-align-middle" *ngIf="canTransferAndWriteoff()">
										<pms-enum-select-button
												formControlName="transferType"
												[enumList]="transferTypes"
												[allOption]="false">
										</pms-enum-select-button>
									</span>
									<span class="display-inline-block margin-right-sm">
										<ejs-dropdownlist id="transferReason"
														  *ngIf="showTransferReasonsDropdown"
														  [dataSource]="transferReasons"
														  formControlName="transferReferenceId"
														  placeholder="Select Transfer Reason"
														  [width]="400"
														  [showClearButton]="true">
										</ejs-dropdownlist>
										<ejs-dropdownlist id="writeoffReason"
														  *ngIf="showWriteoffReasonsDropdown"
														  [dataSource]="writeoffReasons"
														  formControlName="writeoffReferenceId"
														  placeholder="Select Write-off Reason"
														  [width]="400"
														  [showClearButton]="true">
										</ejs-dropdownlist>
									</span>
									<span class="display-inline-block" *ngIf="useItemTransfersOnPayments && showIncludeAllItems()">
										<ejs-checkbox #checkbox label="Include All Items in Transfer" name="includeAllItems" formControlName="includeAllItems"></ejs-checkbox>
									</span>
								</div>
							</div>
						</div>
						<div class="row mb-3" *ngIf="showTransferReasonsDropdown">
							<label class="col-md-2 col-form-label">{{ transferToText }}</label>
							<div class="col-md-10">
								<div class="d-flex flex-wrap align-items-center gap-2">
									<span class="display-inline-block margin-right-md vertical-align-middle" *ngIf="!removeTransferToInsuranceOption && !removeTransferToPatientOption">
										<pms-enum-select-button
												formControlName="payerType"
												[enumList]="payerTypes"
												(click)="updatePersonInsuranceDropdown()"
												[allOption]="false">
										</pms-enum-select-button>
									</span>
									<span class="display-inline-block" *ngIf="!showPayerInvoiceOptions">
										<ejs-dropdownlist id="insurance"
														  *ngIf="personInsuranceList"
														  [dataSource]="personInsuranceList"
														  formControlName="personInsuranceId"
														  placeholder="Select Insurance"
														  [width]="400"
														  [showClearButton]="true">
										</ejs-dropdownlist>
									</span>
									<ng-container *ngIf="showPayerInvoiceOptions">
										<span class="display-inline-block margin-x-xs margin-right-sm">
											<ejs-radiobutton label="New Invoice" name="transferToNewOrExistingInvoice"
															 [value]="TRANSFER_TO_NEW_INVOICE_LABEL"
															 formControlName="transferToNewOrExistingInvoice">
											</ejs-radiobutton>
										</span>
										<span class="display-inline-block margin-x-xs margin-right-sm" *ngIf="showExistingInvoiceOption">
											<ejs-radiobutton (change)="retainInvoiceDropdownInvoiceId()" label="Existing Invoice"
															 name="transferToNewOrExistingInvoice" [value]="TRANSFER_TO_EXISTING_INVOICE_LABEL"
															 formControlName="transferToNewOrExistingInvoice">
											</ejs-radiobutton>
										</span>
										<span class="display-inline-block margin-left-sm" *ngIf="showExistingInvoiceDropdown">
											<ejs-dropdownlist id="invoices" #invoiceDropdown
															  [dataSource]="transferToInvoiceList"
															  formControlName="transferToExistingInvoiceId"
															  placeholder="Select Invoice"
															  [width]="275">
											</ejs-dropdownlist>
										</span>
									</ng-container>
								</div>
							</div>
						</div>
						<div class="row mb-3" *ngIf="!useItemTransfersOnPayments">
							<label class="col-md-2 col-form-label">Amount</label>
							<div class="col-md-10">
								<div class="d-flex flex-wrap align-items-center gap-2">
									<span class="display-inline-block">
										<pms-always-set-currency-input formControlName="transferAmount" [min]="0"></pms-always-set-currency-input>
									</span>
								</div>
							</div>
						</div>
						<div class="row mb-3">
							<div class="col-md-10 offset-sm-2">
								<button ejs-button
										cssClass="e-success"
										type="button"
										iconCss="fa fa-plus"
										(keydown.tab)="onTabKeydown($event)"
										(click)="addTransfer($event)"
										[attr.data-test-id]="'AddTransferWriteOffButton'">
									Add Transfer / Write-off
								</button>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="margin-bottom-sm" *ngIf="showTable && useItemTransfersOnPayments">
				<ag-grid-angular class="ag-theme-alpine"
								 pmsAgAutoFitColumns
								 #paymentItemGrid
								 [rowData]="invoiceItems"
								 (gridReady)="onPaymentItemGridReady()"
								 (cellFocused)="onCellFocus($event)"
								 (cellMouseDown)="onCellClick($event)"
								 [pagination]="false"
								 [attr.data-test-id]="'receivePaymentModalAgGrid'">
				</ag-grid-angular>
			</div>
			<div class="row">
				<div class="col-md-12 col-lg-8 col-xl-9">
					<div class="margin-bottom-sm">
						<div class="margin-bottom-sm">
							<ag-grid-angular class="ag-theme-alpine"
											 pmsAgAutoFitColumns
											 #transferWriteOffGrid
											 [domLayout]="'autoHeight'"
											 [rowData]="transfers"
											 (gridReady)="onTransferItemGridReady()"
											 [pagination]="false"
											 [attr.data-test-id]="'receivePaymentModalTransferWriteOffAgGrid'">
							</ag-grid-angular>
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-4 col-xl-3">
					<table class="table table-bordered table-sm text-end margin-bottom-0">
						<tbody>
						<tr class="bg-default text-uppercase" *ngIf="!readOnly">
							<td>Current Balance</td>
							<td [attr.data-test-id]="'receivePaymentTotalCurrentBalanceLabel'">{{ totalCurrentBalance | currency}}</td>
						</tr>
						<tr>
							<td>Invoice Paid</td>
							<td [attr.data-test-id]="'receivePaymentInvoicePaymentAmountLabel'">{{ invoicePaymentAmount | currency }}</td>
						</tr>
						<tr *ngIf="showPaymentColumn">
							<td>Items Paid</td>
							<td [attr.data-test-id]="'receivePaymentPaymentTotalLabel'">{{ itemPaymentTotal | currency }}</td>
						</tr>
						<tr>
							<td>Amount Transferred</td>
							<td [attr.data-test-id]="'receivePaymentTransferTotalLabel'">{{ itemTransfersTotal | currency }}</td>
						</tr>
						</tbody>
						<tfoot *ngIf="!readOnly">
						<tr class="bg-info text-uppercase">
							<td><strong>After Payments and Transfers</strong></td>
							<td [attr.data-test-id]="'receivePaymentTotalBalanceAfterLabel'"><strong>{{ totalBalanceAfterTransferAndPayment | currency }}</strong></td>
						</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<button ejs-button cssClass="float-start margin-left-0" type="button" (click)="autoPay()" *ngIf="useItemTransfersOnPayments && !readOnly" [attr.data-test-id]="'receivePaymentModalAutoPayButton'">AutoPay</button>
		<button ejs-button iconCss="fa fa-times" type="button" (click)="closeModal()" [attr.data-test-id]="'receivePaymentModalCancelButton'">Cancel</button>
		<button ejs-button [isPrimary]="true" type="submit" (click)="closeModal(true)" *ngIf="!readOnly" [attr.data-test-id]="'receivePaymentModalSaveButton'">Save</button>
	</ng-template>
</ejs-dialog>
<ng-template #noOptions>
	You do not have permission to write-off items associated with this invoice. Contact your administrator to get permission.
</ng-template>
<ng-template #adjustmentTooltip let-data>
	<div class="rev-custom-tooltip-content" [attr.data-test-id]="'receivePaymentModalAdjustmentTooltip'" *ngIf="filterAdjustments(data?.invoiceItemDetails?.itemAdjustments, false)?.length && filterAdjustments(data?.invoiceItemDetails?.itemAdjustments, false).length !== 0">
		<table class="table table-bordered table-sm margin-bottom-0">
			<thead>
			<tr>
				<th>Adjustment</th>
				<th>Details</th>
				<th class="text-end">Amount</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let adjustment of sortBy(filterAdjustments(data?.invoiceItemDetails?.itemAdjustments, false), 'id')">
				<td>{{adjustment.type}}</td>
				<td>{{adjustment.details}}</td>
				<td class="text-end">{{adjustment.amount | currency}}</td>
			</tr>
			</tbody>
		</table>
	</div>
</ng-template>
<ng-template #totalDiscountTooltip let-data>
	<div class="rev-custom-tooltip-content" [attr.data-test-id]="'receivePaymentModalTotalDiscountTooltip'" *ngIf="filterAdjustments(data?.invoiceItemDetails?.itemAdjustments, true)?.length && filterAdjustments(data?.invoiceItemDetails?.itemAdjustments, true).length !== 0">
		<table class="table table-bordered table-sm margin-bottom-0">
			<thead>
			<tr>
				<th>Adjustment</th>
				<th>Details</th>
				<th class="text-end">Amount</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let adjustment of sortBy(filterAdjustments(data?.invoiceItemDetails?.itemAdjustments, true), 'id')">
				<td>{{adjustment.type}}</td>
				<td>{{adjustment.details}}</td>
				<td class="text-end">{{adjustment.amount | currency}}</td>
			</tr>
			</tbody>
		</table>
	</div>
</ng-template>
<ng-template #taxTooltip let-data>
	<div class="rev-custom-tooltip-content" [attr.data-test-id]="'receivePaymentModalTaxTooltip'" *ngIf="data?.invoiceItemDetails?.itemTaxes?.length &&  data?.invoiceItemDetails?.itemTaxes?.length !== 0">
		<table class="table table-bordered table-sm margin-bottom-0">
			<thead>
			<tr>
				<th>Tax</th>
				<th class="text-end">Amount</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let tax of sortBy(data?.invoiceItemDetails?.itemTaxes, 'taxId')">
				<td>{{tax.taxName}}</td>
				<td class="text-end">{{tax.taxAmount | currency}}</td>
			</tr>
			</tbody>
		</table>
	</div>
</ng-template>
<ng-template #transferAmountColumn let-data let-column="params.column">
	<ng-container *ngIf="getInvoiceItemControl(column.getColId(), data?.invoiceItem?.id)">
		<pms-always-set-currency-input
				*ngIf="!isAggregateRow(data)"
				[revFocusInput]="isCellSelected(data?.invoiceItem?.id, column.getColId())"
				[highlightInputOnFocus]="true"
                (inputBlur)="onInputBlur()"
				[formControl]="getInvoiceItemControl(column.getColId(), data.invoiceItem.id)">
		</pms-always-set-currency-input>
	</ng-container>
	<span *ngIf="isAggregateRow(data)">{{getTransferAmountValue(column.getColId())}}</span>
</ng-template>
<ng-template #paymentAmountColumn let-data>
	<ng-container *ngIf="getInvoiceItemControl('paymentAmount', data?.invoiceItem?.id)">
		<pms-always-set-currency-input
				*ngIf="!isAggregateRow(data)"
				[revFocusInput]="isCellSelected(data?.invoiceItem?.id, 'paymentAmount')"
				[highlightInputOnFocus]="true"
                (inputBlur)="onInputBlur()"
				[formControl]="getInvoiceItemControl('paymentAmount', data.invoiceItem.id)">
		</pms-always-set-currency-input>
	</ng-container>
	<span *ngIf="isAggregateRow(data)">{{data.paymentAmount | currency}}</span>
</ng-template>
<ng-template #adjustmentsColumn let-data>
	<ng-container *ngIf="getItemByItem(data?.invoiceItem?.id)">
		<div *ngIf="!isAggregateRow(data)">{{getItemByItem(data.invoiceItem.id).adjustmentTotal | currency}}</div>
	</ng-container>
	<span *ngIf="isAggregateRow(data)" class="text-end">{{data.adjustmentTotal | currency}}</span>
</ng-template>
<ng-template #paymentTotalColumn let-data>
	<ng-container *ngIf="getItemByItem(data?.invoiceItem?.id)">
		<div *ngIf="!isAggregateRow(data)">{{getItemByItem(data.invoiceItem.id).paymentTotalAmount | currency}}</div>
	</ng-container>
	<span *ngIf="isAggregateRow(data)" class="text-end">{{data.paymentTotalAmount | currency}}</span>
</ng-template>
<ng-template #balanceColumn let-data>
	<ng-container *ngIf="getItemByItem(data?.invoiceItem?.id)">
		<div *ngIf="!isAggregateRow(data)" [class.text-danger]="getItemByItem(data.invoiceItem.id).balance < 0"> {{ getItemByItem(data.invoiceItem.id).balance | currency }}</div>
	</ng-container>
	<span *ngIf="isAggregateRow(data)" class="text-end">{{data.balance | currency}}</span>
</ng-template>
<ng-template #transferNumberColumn let-data>
	{{ getTransferNumber(data) }}
</ng-template>
<ng-template #transferTypeColumn let-data>
	{{ getTypeLabel(data.transferRequest) }}
</ng-template>
<ng-template #transferReasonColumn let-data>
	<span revTooltip [tooltipContent]="getReason(data.transferRequest)">{{getReason(data.transferRequest)}}</span>
</ng-template>
<ng-template #transferToColumn let-data>
	<span revTooltip [tooltipContent]="getTransferTo(data.transferRequest)">{{getTransferTo(data.transferRequest)}}</span>
</ng-template>
<ng-template #transferRemoveColumn let-data>
	<rev-button
			buttonIcon="minus"
			buttonStyle="danger"
			buttonTooltip="Remove this transfer/write-off"
			revEventStopPropagation
			(buttonClick)="removeTransfer(getTransferIndexById(data.id), data)"
			dataTestId="receivePaymentsTransferRemoveButton">
	</rev-button>
</ng-template>
<div class="ng-hide" #adjustmentSyncfusionTooltip [attr.data-test-id]="'receivePaymentModalSyncFusionTooltip'">
	<table class="table table-bordered table-sm margin-bottom-0">
		<thead>
		<tr>
			<th>Adjustment</th>
			<th>Details</th>
			<th class="text-end">Amount</th>
		</tr>
		</thead>
		<tbody>
		<tr *ngFor="let adjustment of sortBy(filterAdjustments(tooltipData?.invoiceItemDetails?.itemAdjustments, tooltipDiscount), 'id')">
			<td>{{adjustment.type}}</td>
			<td>{{adjustment.details}}</td>
			<td class="text-end">{{adjustment.amount | currency}}</td>
		</tr>
		</tbody>
	</table>
</div>
<div class="ng-hide" #taxSyncfusionTooltip [attr.data-test-id]="'receivePaymentModalTaxSyncfusionTooltip'">
	<table class="table table-bordered table-sm margin-bottom-0">
		<thead>
		<tr>
			<th>Tax</th>
			<th class="text-end">Amount</th>
		</tr>
		</thead>
		<tbody>
		<tr *ngFor="let tax of sortBy(tooltipData?.invoiceItemDetails?.itemTaxes, 'taxId')">
			<td>{{tax.taxName}}</td>
			<td class="text-end">{{tax.taxAmount | currency}}</td>
		</tr>
		</tbody>
	</table>
</div>
